import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { AccountLayout } from "../../layouts";
import { AuthService } from "../../services";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckIcon from "@mui/icons-material/Check";
import { QUERY_OPTIONS } from "../../common/constants";
import { useQuery } from "@tanstack/react-query";

const useMaskedData = () =>
	useQuery({
		queryKey: ["mask-data"],
		queryFn: () => AuthService.maskData(),
		refetchOnWindowFocus: false,
	});
const useSignOut = () =>
	useQuery({
		queryKey: ["log-out"],
		queryFn: () => AuthService.signOut(),
		refetchOnWindowFocus: false,
	});

// const LOGIN_URL = "/simplepay/v2/"; //  LOCAL
const LOGIN_URL = "/"; //  LIVE 
const REDIRECT_DELAY_MS = 8000;

export const LogoutPage = () => {
	// const { data: maskData } = useMaskedData();

	// const { data: logOut } = useSignOut();


	// useEffect(() => {
	// 	if (logOut) {
	// 		localStorage.clear();


	// 		window.location.href = "/simplepay/v2/";                     //for LOCAL
	// 		// window.location.href = "/";                               //for LIVE



	// 		window.sessionStorage.setItem("maskEnabled", "true");
	// 		sessionStorage.removeItem("unmaskTime");
	// 	}
	// 	// AuthService.signOut();
	// }, [logOut]);

	const { data: logOut, isLoading } = useSignOut();
	const { data: maskData } = useMaskedData();
	const [cleared, setCleared] = useState(false);

	useEffect(() => {
		if (logOut) {
			localStorage.clear();
			window.sessionStorage.setItem("maskEnabled", "true");
			sessionStorage.removeItem("unmaskTime");
			setCleared(true);


			const timer = setTimeout(() => {
				window.location.href = LOGIN_URL;
			}, REDIRECT_DELAY_MS);
			return () => clearTimeout(timer);
		}
	}, [logOut]);

	const content = (
		<Box sx={{ textAlign: "center" }}>
			{isLoading || !cleared ? (
				<>
					<CircularProgress size={32} sx={{ mb: 2 }} />
					<Typography variant="body1" color="text.secondary">
						Signing you out…
					</Typography>
				</>
			) : (
				<>
					<Box
						sx={{
							width: 52,
							height: 52,
							borderRadius: "50%",
							bgcolor: "success.light",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							mx: "auto",
							mb: 2.5,
						}}
					>
						<CheckIcon sx={{ color: "success.main", fontSize: 26 }} />
					</Box>

					<Typography variant="h5" fontWeight={500} gutterBottom>
						You've been signed out
					</Typography>

					<Typography
						variant="body2"
						color="text.secondary"
						sx={{ mb: 3.5, maxWidth: 280, mx: "auto" }}
					>
						Your session has ended and local data has been cleared.
						Sign back in whenever you're ready.
					</Typography>

					<Button
						variant="contained"
						fullWidth
						sx={{ maxWidth: 220, textTransform: "none", py: 1 }}
						onClick={() => (window.location.href = LOGIN_URL)}
					>
						Sign in again
					</Button>

					<Typography variant="caption" color="text.disabled" sx={{ display: "block", mt: 2.5 }}>
						Redirecting automatically in a few seconds…
					</Typography>
					{/* <CheckCircleOutlineIcon
						sx={{ fontSize: 48, color: "primary.main", mb: 2 }}
					/>
					<Typography variant="h4" fontWeight={700} gutterBottom>
						You've Been Signed Out
					</Typography>
					<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
						Your session has been cleared. You can sign back in anytime.
					</Typography>
					<Button
						variant="contained"
						href={LOGIN_URL}
						sx={{ textTransform: "none", px: 4 }}
					>
						Sign In Again
					</Button> */}
				</>
			)}
		</Box>
	);
	return (
		<AccountLayout
			// contents={"Logout page session and storage clear login here"}
			contents={content}
			contentColumns={5}
		/>
	);
};

// import { Box, Button, CircularProgress, Typography } from "@mui/material";
// import { useEffect, useState } from "react";

// import { AccountLayout } from "../../layouts";
// import { AuthService } from "../../services";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import CheckIcon from "@mui/icons-material/Check";
// import { QUERY_OPTIONS } from "../../common/constants";
// import { useQuery } from "@tanstack/react-query";

// const useSignOut = () =>
// 	useQuery({
// 		queryKey: ["log-out"],
// 		queryFn: () => AuthService.signOut(),
// 		refetchOnWindowFocus: false,
// 	});

// const LOGIN_URL = "/simplepay/v2/"; // swap for LIVE as needed
// const REDIRECT_DELAY_MS = 3000;

// export const LogoutPage = () => {
// 	const { data: logOut } = useSignOut();
// 	const [cleared, setCleared] = useState(false);

// 	useEffect(() => {
// 		if (logOut) {
// 			localStorage.clear();
// 			window.sessionStorage.setItem("maskEnabled", "true");
// 			sessionStorage.removeItem("unmaskTime");
// 			setCleared(true);

// 			// const timer = setTimeout(() => {
// 			// 	window.location.href = LOGIN_URL;
// 			// }, REDIRECT_DELAY_MS);
// 			// return () => clearTimeout(timer);
// 		}
// 	}, [logOut]);

// 	const content = (
// 		<Box sx={{ textAlign: "center", px: 2 }}>
// 			<Box
// 				sx={{
// 					width: 52,
// 					height: 52,
// 					borderRadius: "50%",
// 					bgcolor: "success.light",
// 					display: "flex",
// 					alignItems: "center",
// 					justifyContent: "center",
// 					mx: "auto",
// 					mb: 2.5,
// 				}}
// 			>
// 				<CheckIcon sx={{ color: "success.main", fontSize: 26 }} />
// 			</Box>

// 			<Typography variant="h5" fontWeight={500} gutterBottom>
// 				You've been signed out
// 			</Typography>

// 			<Typography
// 				variant="body2"
// 				color="text.secondary"
// 				sx={{ mb: 3.5, maxWidth: 280, mx: "auto" }}
// 			>
// 				Your session has ended and local data has been cleared.
// 				Sign back in whenever you're ready.
// 			</Typography>

// 			<Button
// 				variant="contained"
// 				fullWidth
// 				sx={{ maxWidth: 220, textTransform: "none", py: 1 }}
// 				onClick={() => (window.location.href = LOGIN_URL)}
// 			>
// 				Sign in again
// 			</Button>

// 			<Typography variant="caption" color="text.disabled" sx={{ display: "block", mt: 2.5 }}>
// 				Redirecting automatically in a few seconds…
// 			</Typography>
// 		</Box>
// 	);

// 	return <AccountLayout contents={content} contentColumns={5} />;
// };